<template>
  <ul class="related-posts">
    <li v-for="slide in posts" :key="slide.id">
      <blog-tile
        tile-style="slide"
        :post-image="slide.featuredImage?.node"
        :post-title="slide.title"
        :post-date="slide.dateGmt"
        :post-uri="slide.uri"
        :post-categories="slide.categories.nodes"
        :post-author="slide.author?.node" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useApiStore } from "~/stores/apiStore";
import { ref } from "#imports";

const props = defineProps<{
  postId?: string | number,
  postIds?: string,
  filterCategory?: string,
  postCount?: string,
}>();

const apiStore = useApiStore();
const posts = ref([]);

// Return posts related to given post id or latest posts
const getRelatedPosts = async () => {
  posts.value = [];
  const allData = await apiStore.getData(`/wp-json/content-search/v1/search?type=blog-related&post-id=${props.postId}`);

  if (allData?.results) {
    posts.value = allData.results;
  }
};

// Return posts related to given category slug
const getPostsViaCategory = async () => {
  posts.value = [];
  const allData = await apiStore.getData(`/wp-json/content-search/v1/search?type=blog-related&filter-category=${props.filterCategory}&post-count=${props.postCount ?? 6}`);

  if (allData?.results) {
    posts.value = allData.results;
  }
};

// Return posts for given post ids
const getPostsViaIds = async () => {
  posts.value = [];
  const allData = await apiStore.getData(`/wp-json/content-search/v1/search?type=blog-related&post-ids=${props.postIds}`);

  if (allData?.results) {
    posts.value = allData.results;
  }
};

if (props.filterCategory) {
  getPostsViaCategory();
} else if (props.postIds) {
  getPostsViaIds();
} else {
  getRelatedPosts();
}
</script>

<style lang="scss">
@use "~/common/scss/variables";
@use "~/common/scss/mq";

.related-posts {
  display: grid;
  gap: 1rem;
  grid-template: "1 2 3" auto / 1fr 1fr 1fr;
  list-style: none;

  @include mq.mq(variables.$mq-1-max) {
    grid-template: "1" auto / 100%;
  }
}
</style>
